export default __webpack_public_path__ + "static/media/Poppins-ThinItalic.9d5e661e.ttf";